// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.coolbitx.cwsapp",
    name: "CoolWallet",
    homepage: "https://coolwallet.io/",
    image_id: "f581365d-e844-4d21-8e35-44a755a32d00",
    app: {
        browser: null,
        ios: "https://itunes.apple.com/us/app/coolwallet-s-2018/id1328764142",
        android: "https://play.google.com/store/apps/details?id=com.coolbitx.cwsapp",
        mac: "https://itunes.apple.com/us/app/coolwallet-s-2018/id1328764142",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "com.coolbitx.cwsapp",
    mobile: {
        native: "coolwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map